//warehouse
import machine from "./api/MachineAPI";
import MachineProduct from "./api/Machine/MachineProductAPI";
import MachineSheet from "./api/Machine/MachineSheetAPI";
import ImportProduct from "./api/Products/ImportProductsAPI";
import ExportProduct from "./api/Products/ExportProductAPI";
import material from "./api/Materials/MaterialAPI";
import importMaterial from "./api/Materials/MaterialImportAPI";
import exportMaterial from "./api/Materials/MaterialExportAPI";
import FactorialMaterial from "./api/FactorialMaterial/FactorialMaterialAPI";
import FactorialMaterialImport from "./api/FactorialMaterial/FactorialMaterialImportAPI";
import FactorialMaterialExport from "./api/FactorialMaterial/FactorialMaterialExportAPI";

import Sheet from "./api/Sheets/SheetAPI";
import ImportSheet from "./api/Sheets/SheetImportAPI";
import ExportSheet from "./api/Sheets/SheetExportAPI";
import ReportProduct from "./api/Reports/ReportProductAPI";
import ReportSheet from "./api/Reports/ReportSheetAPI";
import products from "./api/Products/ProductAPI";
import productType from "./api/Products/ProductTypeAPI";
import productOverview from "./api/Products/ProductOverviewAPI";
import produceReport from "./api/Reports/ProduceReport";

//sale manage
import order from "./api/Sale/OrderAPI";
import invoice from "./api/Sale/InvoiceAPI";
import SpecialCustomer from "./api/Sale/ReportSpecialCustomerAPI";
import ExampleProduct from "./api/Sale/ExampleProductAPI";
import ExampleGift from "./api/Sale/ExampleGiftAPI";
import seller from "./api/Person/SellerAPI";
import customer from "./api/Person/CustomerAPI";
import BagType from "./api/Purchasing/BagTypeAPI";
import  SaveExportation from "./api/Sale/SaveExportationAPI";
import Promotion from "./api/Sale/PromotionAPI"
import SaleReturnProduct from "./api/Sale/SaleReturnProductsAPI"
import vendor from "./api/Person/VendorAPI";
import PromotionOther from "./api/Sale/PromotionsOtherAPI";
import OverviewSale from "./api/Sale/OverviewForSaleAPI";


//common
import transportType from "./api/Transportations/TransportTypeAPI";
import auth from "./api/AuthAPI";
import Common from "./api/CommonAPI";
import Transportation from "./api/Transportations/TransportationAPI";
import PDF from "./api/DownloadPDF_API";
import Position from "./api/Person/PositionAPI";
import Department from "./api/Person/DepartmentAPI";

//purchase
import MaterialInspect from "./api/Purchasing/MaterialInspectAPI";
import CheckList from "./api/Purchasing/CheckListAPI"
import PreOrder from "./api/Purchasing/PreOrderAPI"
import PurchaseOrder from "./api/Purchasing/PurchaseOrderAPI"
import RROrder from "./api/Purchasing/RROrderAPI"
import CheckBag from  "./api/Purchasing/CheckedBagAPI"
import BagData from  "./api/Purchasing/BagDataAPI"
import PaymentPurchase from "./api/Purchasing/PurchasePaymentAPI"

//driver
import Driver from  "./api/Transportations/DriverAPI"
import DriverBonus from  "./api/Transportations/DriverBonusAPI"
import DriverDetails from  "./api/Transportations/DriverDetailsAPI"
import InsuranceFee from  "./api/Transportations/InsuranceAPI"
import Deposit from  "./api/Transportations/DepositAPI"
import Repair from  "./api/Transportations/RepairAPI"
import Damages from  "./api/Transportations/DamagesAPI"
import Shipping from  "./api/Transportations/ShippingFeeAPI"

// Accounting.
import ReceivableSellers from  "./api/Accounting/SellerAPI"
import Billing from  "./api/Accounting/BillingAPI"
import Payment from  "./api/Accounting/PaymentAPI"
import BillingPayoff from  "./api/Accounting/BillingPayoffAPI"
import BillingPayment from  "./api/Accounting/BillingPaymentAPI"
import RRPayoff from "./api/Accounting/RRPayoffAPI"
import PaymentAccount from "./api/Accounting/PaymentAccountAPI"
import WaitingPayment from "./api/Accounting/WaitingPaymentAPI"
import invoicePayoff from "./api/Accounting/InvoicePayoffAPI"
import ChequeListPayoff from "./api/Accounting/ChequeListPayoffAPI"
import Bank from "./api/Accounting/BankAPI"
import TaxInvoice from "./api/Accounting/TaxInvoiceAPI"
import TaxPayment from "./api/Accounting/TaxPaymentAPI";
import TaxPayoff from "./api/Accounting/TaxPayoffAPI";
import BillingRE from "./api/Accounting/BillingREAPI";
import InvoicePayoffOther from "./api/Accounting/InvoicePayoffOtherAPI";
import InvoicePayoffOtherAccount from "./api/Accounting/InvoicePayoffOtherAccountAPI";

//transaction
import Transaction from  "./api/Transactions/TransactionAPI"

//HR
import Employee from  "./api/HR/EmployeeAPI"
import Holiday from  "./api/HR/HolidayAPI"
import LeaveDay from  "./api/HR/LeaveDayAPI"
import RateBonusSale from  "./api/HR/RateBonusSaleAPI"
import WorkScheduleHistory from  "./api/HR/WorkScheduleHistoryAPI"
import RateSalaryHistory from  "./api/HR/RateSalaryHistoryAPI"
import WorkScheduleEmployee from "./api/HR/WorkScheduleEmployeeAPI"
import RentalFee from "./api/Salary/RentalFeeAPI";
import AdvanceWithdraw from "./api/Salary/AdvanceWithdrawAPI";
import ScanEmployee from "./api/HR/ScanEmployeeAPI";
import ElectricityBill from "./api/Salary/ElectricityBillAPI";
import ShoppingEmployee from "./api/Salary/ShoppingEmployeeAPI"
import AdvancePayment from  "./api/Salary/AdvancePaymentAPI"
import AdvancePaymentDetails from "./api/Salary/AdvancePaymentDetailsAPI"
import PaymentSalary from "./api/Salary/PaymentSalaryAPI"
import SettingSocialSecurity from "./api/Salary/SettingSocialSecurityAPI"
import factoryEmployeeExport from "./api/HR/FactoryEmployeeExportAPI";
import factoryEmployeeImport from "./api/HR/FactoryEmployeeImportAPI";
import factoryEmployee from "./api/HR/FactoryEmployeeAPI";
import factoryEmployeeSale from "./api/HR/FactoryEmployeeSaleAPI";
//Dashboard
import Dashboard from "./api/Dashboard/DashboardAPI"
// RealizedGainLoss
import RealizedGainLoss from "./api/Accounting/RealizedGainLossAPI";

export default {
    products,
    produceReport,
    productOverview,
    seller,
    customer,
    order,
    invoice,
    vendor,
    transportType,
    auth,
    machine,
    MachineProduct,
    MachineSheet,
    ImportProduct,
    material,
    importMaterial,
    exportMaterial,
    productType,
    ExportProduct,
    Sheet,
    ImportSheet,
    ExportSheet,
    ReportProduct,
    ReportSheet,
    Common,
    Transportation,
    PDF,
    Position,
    MaterialInspect,
    CheckList,
    PreOrder,
    PurchaseOrder,
    RROrder,
    Driver,
    DriverBonus,
    InsuranceFee,
    Deposit,
    Repair,
    Damages,
    DriverDetails,
    Shipping,
    CheckBag,
    BagData,
    Billing,
    ReceivableSellers,
    Payment,
    PaymentPurchase,
    Transaction,
    BillingPayoff,
    BillingPayment,
    RRPayoff,
    PaymentAccount,
    WaitingPayment,
    Employee,
    Holiday,
    LeaveDay,
    RentalFee,
    AdvanceWithdraw,
    RateBonusSale,
    WorkScheduleHistory,
    RateSalaryHistory,
    WorkScheduleEmployee,
    ScanEmployee,
    Promotion,
    BagType,
    SaveExportation,
    invoicePayoff,
    ChequeListPayoff,
    SaleReturnProduct,
    Dashboard,
    Bank,
    ExampleProduct,
    TaxInvoice,
    SpecialCustomer,
    TaxPayoff,
    ElectricityBill,
    ShoppingEmployee,
    AdvancePayment,
    AdvancePaymentDetails,
    PromotionOther,
    OverviewSale,
    PaymentSalary,
    SettingSocialSecurity,
    TaxPayment,
    Department,
    FactorialMaterial,
    FactorialMaterialImport,
    FactorialMaterialExport,
    RealizedGainLoss,
    ExampleGift,
    BillingRE,
    InvoicePayoffOther,
    InvoicePayoffOtherAccount,
    factoryEmployeeExport,
    factoryEmployee,
    factoryEmployeeImport,
    factoryEmployeeSale,
}
